import { useQuery } from "react-query";
import { QbPurchaseOrder } from "../../types/qb";

export const useQbPurchaseOrders = (teamId: string) => {
  return useQuery<QbPurchaseOrder[], Error>(["qbPos.mock", teamId], () => []);
};
